var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.175,
    height: 22.082,
    viewBox: "0 0 17.175 22.082",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-delete",
    "data-name": "Icon material-delete",
    d: "M8.727,24.128a2.461,2.461,0,0,0,2.454,2.454h9.814a2.461,2.461,0,0,0,2.454-2.454V9.407H8.727Zm15.948-18.4H20.381L19.154,4.5H13.02L11.794,5.727H7.5V8.18H24.675Z",
    transform: "translate(-7.5 -4.5)",
    fill: "#666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.59ce99339fdff2eba823bea9a1095349.svg";
export { ForwardRef as ReactComponent };